import fs from 'node:fs'
import path from 'node:path'
import type { NamespacedExtract } from '@cli-types/next-adapter/snapshots.js'

export function listNamespacedExtracts(
  cwd: string,
  dirPath: string,
  ignoredNamespaces = new Set<string>()
): NamespacedExtract[] {
  const fullDir = path.join(cwd, ...dirPath.split('/'))
  if (!fs.existsSync(fullDir)) {
    return []
  }

  const extracts: NamespacedExtract[] = []
  for (const namespace of fs.readdirSync(fullDir).sort()) {
    if (ignoredNamespaces.has(namespace)) {
      continue
    }

    const namespaceDir = path.join(fullDir, namespace)
    if (!fs.existsSync(namespaceDir) || !fs.statSync(namespaceDir).isDirectory()) {
      continue
    }

    for (const fileName of fs.readdirSync(namespaceDir).sort()) {
      if (!fileName.endsWith('.ts')) {
        continue
      }

      const name = fileName.replace(/\.ts$/, '')
      extracts.push({
        namespace,
        name,
        path: `${dirPath}/${namespace}/${fileName}`
      })
    }
  }

  return extracts.sort((a, b) =>
    `${a.namespace}/${a.name}`.localeCompare(`${b.namespace}/${b.name}`)
  )
}
